import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { useConfig } from '../../hooks';
import { formatDateAsync, MESSAGE_TYPE_SENT } from '../../utilities';

const MessageDate = ({ messageType, label }) => {
  const [date, setDate] = React.useState('');
  const { i18n, t } = useTranslation();
  const {
    fontFamily,
    message: { dateFormat }
  } = useConfig();

  React.useEffect(() => {
    const currentDate = new Date();

    formatDateAsync(currentDate, dateFormat, i18n.language)
      .then(formattedDate => setDate(formattedDate))
      .catch(() => setDate(format(currentDate, dateFormat)));
  }, [dateFormat, i18n.language]);

  return (
    <Root>
      <Content messageType={messageType} textFontFamily={fontFamily}>
        <Label>
          {label} {t('at')}&nbsp;
        </Label>
        <DataWrap>{date}</DataWrap>
      </Content>
    </Root>
  );
};

MessageDate.propTypes = {
  label: PropTypes.string,
  messageType: PropTypes.number
};

const Root = styled.div`
  margin-top: 10px;
  font-size: 10px;
`;

const Content = styled.div`
  padding: 0 4px;
  font-family: ${props => props.textFontFamily};
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: #9a9a9a;
  ${({ messageType }) => {
    if (messageType === MESSAGE_TYPE_SENT) {
      return css`
        text-align: right;
      `;
    }
    return css`
      text-align: left;
    `;
  }}
`;

const Label = styled.span`
  display: inline-block;
  font: inherit;
  color: inherit;
`;

const DataWrap = styled.span`
  display: inline-block;
  font: inherit;
  color: inherit;
`;

export default MessageDate;
